import { useStreamSettingsStore } from '../../../../stores/stream-screen-settings.store';

export type PersonsTrackDensity = 'summary' | 'lanes';

/**
 * Personas track density (compact summary vs per-person lanes).
 * Defaults to `'summary'` when the persisted audit blob predates this key.
 */
export function usePersonsTrackDensity(): {
  density: PersonsTrackDensity;
  setDensity: (density: PersonsTrackDensity) => void;
} {
  const density =
    useStreamSettingsStore((s) => s.audit.personsDensity) ?? 'summary';
  const updateSettings = useStreamSettingsStore((s) => s.updateSettings);

  return {
    density,
    setDensity: (next) => updateSettings({ audit: { personsDensity: next } }),
  };
}
